import { OrderStepConfig } from '../models/order-step';
import { BillingAddressComponent } from '../order/steps/billing-address/billing-address.component';
import { ContractPeriodComponent } from '../order/steps/contract-period/contract-period.component';
import { ContractStartDateComponent } from '../order/steps/contract-start-date/contract-start-date.component';
import { ContractStartWithPriceComponent } from '../order/steps/contract-start-with-price/contract-start-with-price.component';
import { InsuredObjectsComponent } from '../order/steps/insured-objects/insured-objects.component';
import { PaymentDataComponent } from '../order/steps/payment-data/payment-data.component';
import { ProductDescriptionComponent } from '../order/steps/product-description/product-description.component';
import { SingleInsurantComponent } from '../order/steps/single-insurant/single-insurant.component';
import { SubmitComponent } from '../order/steps/submit/submit.component';

export const billingAddress: OrderStepConfig = {
    slug: 'rechnungsadresse',
    component: BillingAddressComponent,
    title: 'Versicherungsnehmer',
};

export const contractPeriod: OrderStepConfig = {
    slug: 'laufzeit',
    component: ContractPeriodComponent,
    title: 'Laufzeit und Vertragsbeginn',
};

export const contractStart: OrderStepConfig = {
    slug: 'vertragsbeginn',
    component: ContractStartDateComponent,
    title: 'Vertragsbeginn',
};

export const contractStartWithPrice: OrderStepConfig = {
    slug: 'vertragsbeginn',
    component: ContractStartWithPriceComponent,
    title: 'Vertragsbeginn',
};

export const insuredObjects: OrderStepConfig = {
    slug: 'versicherte-objekte',
    component: InsuredObjectsComponent,
    title: 'Angaben zu versicherten Geräten',
};

export const paymentData: OrderStepConfig = {
    slug: 'zahlungsdaten',
    component: PaymentDataComponent,
    title: 'Zahlungsdaten',
};

export const singleInsurant: OrderStepConfig = {
    slug: 'versicherte-person',
    component: SingleInsurantComponent,
    title: 'Angaben zur versicherten Person',
};

export const submitContract: OrderStepConfig = {
    slug: 'vertragserklaerungen',
    component: SubmitComponent,
    title: 'Vertragserklärungen',
};

export const defaultLandingPage: OrderStepConfig = {
    slug: '',
    component: ProductDescriptionComponent,
    title: '',
};
